<!-- 模块-编辑资料 -->
<template>
<div>
  <van-popup class="popup" v-model="ifShow" position="right" :overlay="false">
    <div class="popup_title">
      <span>编辑资料</span>
      <van-button type="default" round size="small" @click="ifShow = false">返 回</van-button>
    </div>

    <v-touch class="popup_body" @swiperight="ifShow = false">
      <van-form @submit="on" v-if="msg" class="from">
        <van-field
          readonly
          v-model="card_no"
          label="油卡卡号:"
        />

        <van-field
          v-model="msg.name"
          label="真实姓名:"
          placeholder="请输入真实姓名"
          :rules="[{ validator: ver_name, message: '真实姓名无效' }]"
        />

        <van-field
          type="number"
          v-model="msg.pho"
          label="手机号码:"
          placeholder="请输入手机号码"
          :rules="[{ validator: ver_pho, message: '手机号码无效' }]"
        />

        <van-field
          readonly
          v-model="msg.certificate.name"
          label="证件类型:"
          placeholder="选择证件类型"
          @click="show_type = true"
        />

        <van-field
          v-model="msg.certificate.num"
          label="证件号码:"
          placeholder="请输入证件号码"
          :rules="[{ validator: ver_num, message: '证件号码无效' }]"
        />
        <!-- 车牌键盘 -->
        <van-field
          v-model="msg.car_num"
          label="车牌号码:"
          placeholder="请输入车牌号码（可选）"
          :rules="[{ validator: ver_car_num, message: '车牌号码无效' }]"
          @click-input="show_keybord()"
        />
        <van-field
          v-model="msg.email"
          label="电子邮箱:"
          placeholder="请输入电子邮箱（可选）"
          :rules="[{ validator: ver_email, message: '电子邮箱无效' }]"
        />
        <div class="footer">
          <van-button v-show="$root.systemKeyboard" round block type="info" native-type="submit" :loading="ifOn" :disabled="ifOn">保存资料</van-button>
        </div>
      </van-form>
    </v-touch>

    <!-- 选择证件类型 -->
    <van-popup v-model="show_type" round position="bottom">
      <van-picker show-toolbar :columns="type_data" @cancel="show_type = false" @confirm="choose_type"/>
    </van-popup>
  </van-popup>
  <!-- 车牌键盘 子组件 -->
    <keybord ref="keybord"  @getVal="getValue" @getV="getValue"/>
    </div>
</template>

<style lang="scss" scoped>
.license-container {
  width: 100%;
  height: 600px;

.license-bar {
  padding: 0px;
  height: 30px;
  line-height: 40px;
  display: none;
}
}

.license-buttons {
  height: 40px;
  padding: 0;

    span {
      display: inline-block;
      width: 40px;
      margin-left: 2px;
      margin-bottom: 10px;
      font-size: 0.625rem;
      line-height: 30px;
    }
  }

</style>

<script>
import keybord from './keybord'

export default {
  name: 'card_msg',
  components: {keybord},
  data () {
    return {
      ifShow: false,
      ifOn: false,
      show_type: false,
      card_id: '',
      card_type: '',
      card_no: '',
      msg: null,
      type_data: ['身份证', '居住证', '护照', '军人证', '团员证', '党员证'],
      val: ''
    }
  },

  methods: {
    // 显示弹层val
    show (data) {
      this.card_id = data.card_id
      this.card_type = data.type
      this.card_no = data.card_no
      this.msg = data.msg
      // 未设置证件时，默认选中身份证
      if (this.msg.certificate.type === '') {
        this.msg.certificate.type = 1
        this.msg.certificate.name = '身份证'
      }
      this.ifShow = true
    },

    // 选择证件类型
    choose_type (val, key) {
      this.msg.certificate.name = val
      this.msg.certificate.type = key + 1
      this.show_type = false
    },

    // 验证名称
    ver_name (val) {
      return this.ver_input(1, val)
    },

    // 验证手机
    ver_pho (val) {
      return this.ver_input(2, val)
    },

    // 验证证件号码
    ver_num (val) {
      if (parseInt(this.msg.certificate.type) === 1) {
        return this.ver_input(3, val)
      } else {
        if (val.length === 0) {
          return false
        } else {
          return true
        }
      }
    },

    // 验证邮箱
    ver_email (val) {
      if (val !== '') {
        return this.ver_input(4, val)
      } else {
        return true
      }
    },

    // 验证车牌
    ver_car_num (val) {
      if (val !== '') {
        return this.ver_input(5, val)
      } else {
        return true
      }
    },

    // 提交数据
    on () {
      let data = {
        card_id: this.card_id,
        card_type: this.card_type,
        msg_data: this.msg
      }
      this.ax(this, 'up_card_user', data, (res) => {
        if (res.err_num === 0) {
          this.$notify({ type: 'success', message: res.msg })
          this.$emit('up_data')
          this.ifShow = false
        }
      }, 'on')
    },

    // 车牌键盘显示
    show_keybord () {
      this.$refs.keybord.clickShowKeyboard()
      document.activeElement.blur()
    },

    // 接收子组件的数据
    getValue (val) {
      this.msg.car_num = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/msg.vue